import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { BaseIconButton, Stack, Tooltip } from '@lyearn/ui';
import { KeyResultMetricEnum } from '@/types/schema';

import { KEY_RESULT_METRICS_CONFIG } from './utils';

interface Props {
  metrics?: KeyResultMetricEnum[];
  value?: KeyResultMetricEnum | null;
  size?: 'medium' | 'large';
  onChange: (value: KeyResultMetricEnum) => void;
  disabled?: boolean;
}

const DEFAULT_METRICS = [
  KeyResultMetricEnum.Percentage,
  KeyResultMetricEnum.Number,
  KeyResultMetricEnum.Currency,
  KeyResultMetricEnum.Toggle,
];

const SIZE_CLASSES = {
  medium: 'w-40 h-40',
  large: 'w-48 h-48',
};

const ICON_SIZE_CLASSES = {
  medium: 'w-16 h-16',
  large: 'w-20 h-20',
};

const MetricToogleGroup = (props: Props) => {
  const { t } = useTranslation();
  const { metrics = DEFAULT_METRICS, disabled, size = 'medium', value, onChange } = props;

  return (
    <Stack>
      {metrics.map((metricKey, index) => {
        const metric = KEY_RESULT_METRICS_CONFIG[metricKey];
        const { Icon, labelKey, value: metricValue } = metric;
        const isSelected = metricValue === value;

        return (
          <Tooltip key={metricValue} title={t(labelKey)}>
            <BaseIconButton
              className={cn(
                SIZE_CLASSES[size],
                index === 0 ? 'rounded-s-8' : '-ms-1',
                index === metrics.length - 1 ? 'rounded-e-8' : '',
                isSelected
                  ? 'z-20 border-focus-primary text-icon-active disabled:border-border-medium disabled:bg-bg-secondary disabled:text-icon-placeholder'
                  : 'text-icon-secondary hover:z-10 hover:border-border-dark hover:text-icon-primary',
                'rounded-none border border-solid border-border hover:bg-transparent',
              )}
              disabled={disabled}
              onClick={() => onChange(metricValue)}>
              <Icon className={ICON_SIZE_CLASSES[size]} />
            </BaseIconButton>
          </Tooltip>
        );
      })}
    </Stack>
  );
};

export default MetricToogleGroup;
